import React, { createContext, useState, useContext, useCallback } from 'react';

// Contextオブジェクトを作成
const OrderContext = createContext();

// 他のファイルからContextを簡単に使えるようにするためのカスタムフック
export const useOrder = () => useContext(OrderContext);

// stateの初期値
const initialOrderData = {
  propertyName: '',
  remarks: '',
  invoiceDetails: '', // ★ invoiceDetailsを追加して整合性をとる
  products: [],
};

const initialShippingInfo = {
  selectedId: 'manual',
  manualAddress: { 
    recipientName: '', 
    postalCode: '', 
    address1: '', 
    address2: '', 
    address3: '', 
    phoneNumber: '',
    shippingCompanyName: '',
    shippingBranchName: '',
    shippingDepartmentName: '',
  },
};

// データを提供するProviderコンポーネント
export const OrderProvider = ({ children }) => {
  const [orderId, setOrderId] = useState(null);
  const [orderData, setOrderData] = useState(initialOrderData);
  const [shippingInfo1, setShippingInfo1] = useState(initialShippingInfo);
  const [shippingInfo2, setShippingInfo2] = useState(initialShippingInfo);
  const [showShipping2, setShowShipping2] = useState(false);
  const [saveNewAddress1, setSaveNewAddress1] = useState(true);
  const [saveNewAddress2, setSaveNewAddress2] = useState(true);

  // useCallbackで関数をメモ化し、不要な再生成を防ぐ
  const resetOrder = useCallback(() => {
    setOrderId(null);
    setOrderData(initialOrderData);
    setShippingInfo1(initialShippingInfo);
    setShippingInfo2(initialShippingInfo);
    setShowShipping2(false);
    setSaveNewAddress1(true);
    setSaveNewAddress2(true);
  }, []);

  const value = {
    orderId, setOrderId,
    orderData, setOrderData,
    shippingInfo1, setShippingInfo1,
    shippingInfo2, setShippingInfo2,
    showShipping2, setShowShipping2,
    saveNewAddress1, setSaveNewAddress1,
    saveNewAddress2, setSaveNewAddress2,
    resetOrder,
  };

  return (
    <OrderContext.Provider value={value}>
      {children}
    </OrderContext.Provider>
  );
};